
export const getFormattedDateTime = (dateTimeString: string): string => {
    if (!dateTimeString) {
        return '';
    }
    return new Date(dateTimeString).toLocaleString();
};

export const getDurationString = (seconds?: number | null, alwaysShowMinutes: boolean = true): string => {
    if (!seconds) {
        return '∞';
    }
    const durationSeconds = Math.round(seconds);
    const durationMinutes = Math.floor(durationSeconds / 60);
    const durationHours = Math.floor(durationMinutes / 60);
    const durationRemainingSeconds = Math.round(durationSeconds - durationMinutes * 60);
    const durationRemainingMinuts = Math.round(durationMinutes - durationHours * 60);

    if (alwaysShowMinutes) {
        return `${durationHours > 0 ? `${durationHours} h ` : ''}${durationRemainingMinuts} min ${durationRemainingSeconds} sec`;
    }
    return `${durationHours > 0 ? `${durationHours} h ` : ''}${
        durationRemainingMinuts > 0 ? `${durationRemainingMinuts} min ` : ''
    }${durationRemainingSeconds} sec`;
};

export const getDurationMs = (dateTimeStarted: string, dateTimeLast: string): number => {
    if (!dateTimeLast) {
        return 0;
    }
    return new Date(dateTimeLast).getTime() - new Date(dateTimeStarted).getTime();
};

export const getPlayDuration = (dateTimeStarted: string, dateTimeLast: string): string => {
    if (!dateTimeLast) {
        return '0';
    }
    const durationMiliseconds = getDurationMs(dateTimeStarted, dateTimeLast);
    return getDurationString(durationMiliseconds / 1000);
};